import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { AuthorizationService } from '../../../authorization/services/authorization.service';
import { EnumMicroDroits } from '../../administration/models/micro.droits';
import { PreferenceMessages } from './../../shared/models/component-messages/preference-messages';
import { PreferencesService } from './services/preferences.service';

@Component({
  selector: 'app-preferences-avis-de-pub',
  templateUrl: './preferences-avis-de-pub.component.html',
  styleUrls: ['./preferences-avis-de-pub.component.scss']
})
export class PreferencesAvisDePubComponent implements OnInit {

  public preferenceMessages = new PreferenceMessages();

  public isNewActive = 4;

  isComptesFacturation: boolean;
  isComptesAnnonceur: boolean;

  precUrl: string = "";

  constructor(
    private readonly preferenceService: PreferencesService,
    private readonly authorizationService: AuthorizationService) {
  }

  public ngOnInit() {
    this.precUrl = this.preferenceService.getPreviousUrl();
    this.habilitations();
    if (this.precUrl?.startsWith('/preferencesAvisPub/pref-cpv')) {
      this.isNewActive = 4
      this.activeTab(4)
    }
    if (this.precUrl?.startsWith('/preferencesAvisPub/pref-acheteur-principal')) {
      this.isNewActive = 6
      this.activeTab(6)
    }
  }

  public activeTab(state: number) {

    this.isNewActive = state;

    switch (this.isNewActive) {

      case 2:
        document.getElementById('pills-one-tab')?.classList.remove('active');
        document.getElementById('pills-two-tab')?.classList.add('active');
        document.getElementById('pills-three-tab')?.classList.remove('active');
        if (this.isComptesFacturation) {
          document.getElementById('pills-four-tab')?.classList.remove('active');
        }
        if (this.isComptesAnnonceur) {
          document.getElementById('pills-five-tab')?.classList.remove('active');
        }
        document.getElementById('pills-six-tab')?.classList.remove('active');
        break;

      case 3:
        document.getElementById('pills-one-tab')?.classList.remove('active');
        document.getElementById('pills-two-tab')?.classList.remove('active');
        document.getElementById('pills-three-tab')?.classList.add('active');
        if (this.isComptesFacturation) {
          document.getElementById('pills-four-tab')?.classList.remove('active');
        }
        if (this.isComptesAnnonceur) {
          document.getElementById('pills-five-tab')?.classList.remove('active');
        }
        document.getElementById('pills-six-tab')?.classList.remove('active');
        break;

      case 4:
        document.getElementById('pills-one-tab')?.classList.remove('active');
        document.getElementById('pills-two-tab')?.classList.remove('active');
        document.getElementById('pills-three-tab')?.classList.remove('active');
        if (this.isComptesFacturation) {
          document.getElementById('pills-four-tab')?.classList.add('active');
        }
        if (this.isComptesAnnonceur) {
          document.getElementById('pills-five-tab')?.classList.remove('active');
        }
        document.getElementById('pills-six-tab')?.classList.remove('active');
        break;

      case 5:
        document.getElementById('pills-one-tab')?.classList.remove('active');
        document.getElementById('pills-two-tab')?.classList.remove('active');
        document.getElementById('pills-three-tab')?.classList.remove('active');
        if (this.isComptesFacturation) {
          document.getElementById('pills-four-tab')?.classList.remove('active');
        }
        if (this.isComptesAnnonceur) {
          document.getElementById('pills-five-tab')?.classList.add('active');
        }
        document.getElementById('pills-six-tab')?.classList.remove('active');
        break;

      case 6:
        document.getElementById('pills-one-tab')?.classList.remove('active');
        document.getElementById('pills-two-tab')?.classList.remove('active');
        document.getElementById('pills-three-tab')?.classList.remove('active');
        if (this.isComptesFacturation) {
          document.getElementById('pills-four-tab')?.classList.remove('active');
        }
        if (this.isComptesAnnonceur) {
          document.getElementById('pills-five-tab')?.classList.remove('active');
        }
        document.getElementById('pills-six-tab')?.classList.add('active');
        break;

      default:
        document.getElementById('pills-one-tab')?.classList.add('active');
        document.getElementById('pills-two-tab')?.classList.remove('active');
        document.getElementById('pills-three-tab')?.classList.remove('active');
        if (this.isComptesFacturation) {
          document.getElementById('pills-four-tab')?.classList.remove('active');
        }
        if (this.isComptesAnnonceur) {
          document.getElementById('pills-five-tab')?.classList.remove('active');
        }
        document.getElementById('pills-six-tab')?.classList.remove('active');
        break;
    }
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([
      EnumMicroDroits.DONNEES_FACTURATIONS_GESTION,
      EnumMicroDroits.DONNEES_FACTURATIONS_CONSULTATION])
      .pipe(first())
      .subscribe(isComptesFacturation => { this.isComptesFacturation = isComptesFacturation });


    this.authorizationService.hasAnyMicroRightIn([
      EnumMicroDroits.COMPTES_ANNONCEURS_GESTION,
      EnumMicroDroits.COMPTES_ANNONCEURS_CONSULTATION])
      .pipe(first())
      .subscribe(isComptesAnnonceur => { this.isComptesAnnonceur = isComptesAnnonceur });
  }
}
